function initializePredictiveSearchFeatures() {
  const predictiveSearch = document.querySelector('predictive-search');
  if (!predictiveSearch) return;
  
  const searchForm = predictiveSearch.querySelector('#search-form');
  const searchInput = predictiveSearch.querySelector('#Search');
  const predictiveSearchContainer = predictiveSearch.querySelector('#predictive-search');
  const closeSearchBtn = predictiveSearch.querySelector('.btn--close-search');
  
  let selected = {};
  
  function updateProductImageFromActiveColor(productCard) {
    if (!productCard) return;
    
    const activeColorSwatch = productCard.querySelector('.color-swatch.active-color, .csm_color_click.active-color, [data-color].active-color');
    
    if (!activeColorSwatch) {
      const firstColor = productCard.querySelector('.color-swatch, .csm_color_click, [data-color]');
      if (firstColor) {
        firstColor.classList.add('active-color');
        const productId = firstColor.getAttribute('data-product-id') || 
                         productCard.getAttribute('data-product-id') ||
                         productCard.getAttribute('data-product-handle');
        if (productId) {
          selected[productId] = { color: firstColor.getAttribute('data-color') };
          updateVariantIds(productId);
        }
      }
      return;
    }
    
    const variantImage = activeColorSwatch.getAttribute('data-variant-image') || 
                        activeColorSwatch.getAttribute('data-image') ||
                        activeColorSwatch.getAttribute('data-src');
    
    if (!variantImage) return;
    
    const mainImage = productCard.querySelector('img.product-card__image, .grid-product__image-mask img, img.product-card__image, image-element img, [class*="image"] img');
    
    if (mainImage) {
      let cleanImageUrl = variantImage;
      cleanImageUrl = cleanImageUrl.replace(/_\d+x\./g, '.').replace(/_\d+x$/g, '').replace(/\?v=\d+/g, '').replace(/\.jpg\.jpg$/, '.jpg');
      
      mainImage.src = cleanImageUrl;
      if (mainImage.srcset) mainImage.srcset = cleanImageUrl + ' 1x, ' + cleanImageUrl + ' 2x';
      if (mainImage.hasAttribute('data-src')) mainImage.setAttribute('data-src', cleanImageUrl);
    }
  }

  predictiveSearch.addEventListener("mouseover", function(e) {
    const card = e.target.closest(".product-card");
    if (card && predictiveSearch.contains(card)) {
      card.classList.add("csm_hover");
      updateProductImageFromActiveColor(card);
    }
  });

  predictiveSearch.addEventListener("mouseover", function(e) {
    const quickAdd = e.target.closest(".csm_quick_add");
    if (!quickAdd) return;
    const productCard = quickAdd.closest(".product-card");
    if (productCard && predictiveSearch.contains(productCard)) {
      productCard.classList.add("csm_show_sizes");
      updateProductImageFromActiveColor(productCard);
    }
  });

  function initializeProductColors() {
    const colorSwatches = predictiveSearch.querySelectorAll('.color-swatch[data-product-id], .csm_color_click[data-product-id], [data-color][data-product-id]');
    const productsMap = new Map();
    
    colorSwatches.forEach(swatch => {
      const productId = swatch.getAttribute('data-product-id');
      if (!productId) return;
      if (!productsMap.has(productId)) productsMap.set(productId, []);
      productsMap.get(productId).push(swatch);
    });
    
    productsMap.forEach((swatches, productId) => {
      const hasActive = swatches.some(swatch => swatch.classList.contains('active-color'));
      if (!hasActive && swatches.length > 0) {
        const firstSwatch = swatches[0];
        firstSwatch.classList.add('active-color');
        if (!selected[productId]) selected[productId] = {};
        selected[productId].color = firstSwatch.getAttribute('data-color');
        const productCard = firstSwatch.closest('.product-card') || firstSwatch.closest('.grid-product') || firstSwatch.closest('.product-item');
        if (productCard && predictiveSearch.contains(productCard)) updateProductImageFromActiveColor(productCard);
        updateVariantIds(productId);
      }
    });
  }

  predictiveSearch.addEventListener("click", function(e) {
    const colorEl = e.target.closest(".color-swatch, .csm_color_click, [data-color]");
    if (!colorEl) return;
    const productId = colorEl.getAttribute("data-product-id");
    const color = colorEl.getAttribute("data-color");
    if (!productId || !color) return;
    if (!selected[productId]) selected[productId] = {};
    selected[productId].color = color;

    predictiveSearch.querySelectorAll(`[data-product-id="${productId}"]`).forEach(el => el.classList.remove("active-color"));
    colorEl.classList.add("active-color");

    const productCard = colorEl.closest('.product-card') || colorEl.closest('.grid-product') || colorEl.closest('.product-item');
    if (productCard && predictiveSearch.contains(productCard)) updateProductImageFromActiveColor(productCard);

    updateVariantIds(productId);
  });

  // 🔥 SIZE CLICK → ADD TO CART (redirect fix included)
  predictiveSearch.addEventListener("click", async function(e) {
    const sizeEl = e.target.closest(".csm_card_addart");
    if (!sizeEl) return;

    e.preventDefault();
    e.stopPropagation();

    const productId = sizeEl.getAttribute("data-product-id");
    const size = sizeEl.getAttribute("data-size");
    if (!selected[productId]) selected[productId] = {};
    selected[productId].size = size;

    predictiveSearch.querySelectorAll(`.csm_card_addart[data-product-id="${productId}"]`).forEach(el => el.classList.remove("active-size"));
    sizeEl.classList.add("active-size");

    const productCard = sizeEl.closest('.product-card') || sizeEl.closest('.grid-product') || sizeEl.closest('.product-item');
    if (productCard && predictiveSearch.contains(productCard)) updateProductImageFromActiveColor(productCard);

    const variantId = sizeEl.getAttribute("data-variant-id");
    if (!variantId) return;
    if (sizeEl.classList.contains("adding")) return;
    sizeEl.classList.add("adding");

    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (typeof theme !== 'undefined' && theme.CartDrawer) {
        const cart = new theme.CartDrawer();
        cart.init();
        cart.open();
      } else {
        openCartDrawer();
      }

    } catch (err) {
      console.error(err);
    }

    setTimeout(() => sizeEl.classList.remove("adding"), 500);
  });

  function updateVariantIds(productId) {
    const card = predictiveSearch.querySelector(`[data-product-id="${productId}"]`);
    if (!card) return;
    const variantTag = card.querySelector(".variant-data");
    if (!variantTag) return;

    let variants = [];
    try { variants = JSON.parse(variantTag.textContent); } catch(err) { console.error(err); return; }

    const sel = selected[productId] || {};
    predictiveSearch.querySelectorAll(`.csm_card_addart[data-product-id="${productId}"]`).forEach(sizeEl => {
      const size = sizeEl.getAttribute("data-size");
      const match = variants.find(v => v.option1 === sel.color && v.option2 === size);
      if (match) {
        sizeEl.setAttribute("data-variant-id", match.id);
        if (match.available) {
          sizeEl.classList.remove("disabled");
          sizeEl.removeAttribute("disabled");
        } else {
          sizeEl.classList.add("disabled");
          sizeEl.setAttribute("disabled", "disabled");
        }
      }
    });
  }

  predictiveSearch.addEventListener('click', function(e) {
    const productCard = e.target.closest('.product-card') || e.target.closest('.grid-product') || e.target.closest('.product-item');
    if (productCard && predictiveSearch.contains(productCard)) updateProductImageFromActiveColor(productCard);
  });

  predictiveSearch.addEventListener('mouseover', function(e) {
    const productCard = e.target.closest('.product-card') || e.target.closest('.grid-product') || e.target.closest('.product-item');
    if (productCard && predictiveSearch.contains(productCard)) updateProductImageFromActiveColor(productCard);
  });

  predictiveSearch.addEventListener("mouseover", function(e) {
    const selectors = ['.csm_color_click','.color-swatch','.swatch','.variant-swatch','[data-variant-image]','[data-swatch]','[data-color]'];
    let colorEl = null;
    for (let selector of selectors) {
      colorEl = e.target.closest(selector);
      if (colorEl && predictiveSearch.contains(colorEl)) break;
    }
    if (!colorEl) return;
    if (colorEl.classList.contains("active-color")) return;
  });

  if (searchForm && searchInput) {
    searchForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const searchTerm = searchInput.value.trim();
      if (!searchTerm) return;

      predictiveSearchContainer.innerHTML = '';
      predictiveSearchContainer.style.display = 'block';

      fetch(`/search?q=${encodeURIComponent(searchTerm)}&type=product`)
        .then(response => response.text())
        .then(html => {
          const temp = document.createElement('div');
          temp.innerHTML = html;
          temp.querySelectorAll('#PageContainer, .page-container, header, footer, nav, aside, script, style, link, meta').forEach(el => el.remove());
          const productElements = temp.querySelectorAll('.grid__item, .product-item, .product-card, [class*="product"], [data-product-id]');
          if (productElements.length > 0) {
            let resultsHTML = '';
            productElements.forEach(item => {
              const title = item.querySelector('h2, h3, h4, .product-title')?.textContent?.trim() || 'Product';
              const image = item.querySelector('img')?.src || '';
              const link = item.querySelector('a')?.href || '#';
              const price = item.querySelector('.price, .product-price, .money')?.textContent?.trim() || '';
              resultsHTML += `<a href="${link}" class="search-result-item">${image ? `<img src="${image}" alt="${title}" width="80" height="80">` : ''}<div class="search-result-info"><div class="search-result-title">${title}</div>${price ? `<div class="search-result-price">${price}</div>` : ''}</div></a>`;
            });
            predictiveSearchContainer.innerHTML = resultsHTML;
            setTimeout(initializeProductColors, 200);
          } else {
            predictiveSearchContainer.style.display = 'block'; // 🔥 fix display:none issue
          }
          addCartEventListeners();
        })
        .catch(() => { predictiveSearchContainer.style.display = 'block'; }); // 🔥 fix display:none issue
    });

    searchInput.addEventListener('input', debounce(function() {
      const searchTerm = searchInput.value.trim();
      if (searchTerm.length >= 1) { // 🔥 fix for single & full word search
        fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product`)
          .then(response => response.json())
          .then(data => {
            const products = data.resources?.results?.products || [];
            if (products.length > 0) {
              let html = '';
              products.forEach(product => {
                html += `<a href="${product.url}" class="predictive-item">${product.image ? `<img src="${product.image}" alt="${product.title}" width="50">` : ''}<span>${product.title}</span></a>`;
              });
              predictiveSearchContainer.innerHTML = html;
              predictiveSearchContainer.style.display = 'block';
              setTimeout(initializeProductColors, 100);
            } else {
              predictiveSearchContainer.style.display = 'block'; // 🔥 keep visible even if empty
            }
          })
          .catch(() => { predictiveSearchContainer.style.display = 'block'; });
      } else {
        predictiveSearchContainer.style.display = 'block';
      }
    }, 300));
  }

  if (closeSearchBtn) closeSearchBtn.addEventListener('click', function(e){ e.preventDefault(); hideSearch(); });
  document.addEventListener('click', function(e){ if (searchForm && !searchForm.contains(e.target) && predictiveSearchContainer && !predictiveSearchContainer.contains(e.target)) hideSearch(); });

  function addCartEventListeners() {
    const cartForms = predictiveSearchContainer.querySelectorAll('form[action*="/cart/add"]');
    cartForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        handleAddToCart(this);
      });
    });
  }

  async function handleAddToCart(form) {
    const formData = new FormData(form);
    const addButton = form.querySelector('[type="submit"]');
    if (addButton) addButton.disabled = true;

    try {
      hideSearch();
      await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } });
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();
      updateCartCount(cartData.item_count);
      openCartDrawer(cartData);
    } catch (error) { console.error('Cart error:', error); }
    finally { if (addButton) addButton.disabled = false; }
  }

  function updateCartCount(count) { document.querySelectorAll('.cart-count, .cart-count-bubble').forEach(el => { el.textContent = count; }); }

  function openCartDrawer(cartData = null) {
    let cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
    if (!cartDrawer) createCartDrawer();
    if (cartData) updateCartContent(cartData);
    cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
    if (cartDrawer) cartDrawer.classList.add('is-open');
    const overlay = document.createElement('div');
    overlay.className = 'cart-overlay';
    overlay.addEventListener('click', closeCartDrawer);
    document.body.appendChild(overlay);
  }

  function closeCartDrawer() {
    const cartDrawer = document.querySelector('.cart-drawer');
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    const overlay = document.querySelector('.cart-overlay');
    if (overlay) overlay.remove();
    hideSearch();
  }

  function createCartDrawer() {
    const drawerHTML = `<div class="cart-drawer"><div class="cart-header"><h3>Cart</h3><button class="cart-close">&times;</button></div><div class="cart-items"></div><div class="cart-footer"><a href="/cart" class="btn-view-cart">View Cart</a><a href="/checkout" class="btn-checkout">Checkout</a></div></div>`;
    document.body.insertAdjacentHTML('beforeend', drawerHTML);
    document.querySelector('.cart-close').addEventListener('click', closeCartDrawer);
  }

  function updateCartContent(cart) {
    const itemsContainer = document.querySelector('.cart-items');
    if (!itemsContainer) return;
    let itemsHTML = '';
    if (cart.items && cart.items.length > 0) {
      cart.items.forEach(item => {
        itemsHTML += `<div class="cart-item"><img src="${item.image}" alt="${item.title}" width="60"><div class="cart-item-info"><h4>${item.title}</h4><div>${formatMoney(item.line_price)}</div><div>Qty: ${item.quantity}</div></div></div>`;
      });
    } else { itemsHTML = '<p>Your cart is empty</p>'; }
    itemsContainer.innerHTML = itemsHTML;
  }

  function hideSearch() {
    if (predictiveSearchContainer) predictiveSearchContainer.style.display = 'none';
    if (searchInput) searchInput.value = '';
  }

  function debounce(func, wait) { let timeout; return function(...args){ clearTimeout(timeout); timeout = setTimeout(() => func.apply(this,args), wait); }; }
  function formatMoney(cents) { return '$' + (cents/100).toFixed(2); }

  setTimeout(initializeProductColors, 100);
}

document.addEventListener('DOMContentLoaded', function() {
  const checkPredictiveSearch = setInterval(function() {
    if (document.querySelector('predictive-search')) {
      clearInterval(checkPredictiveSearch);
      initializePredictiveSearchFeatures();
    }
  }, 100);

  if (document.querySelector('predictive-search')) initializePredictiveSearchFeatures();
});

const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList') {
      if (document.querySelector('predictive-search') && !document.querySelector('predictive-search').hasAttribute('data-initialized')) {
        initializePredictiveSearchFeatures();
        document.querySelector('predictive-search').setAttribute('data-initialized', 'true');
      }
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });

window.hideSearch = function() {
  const predictiveSearch = document.querySelector('predictive-search');
  if (!predictiveSearch) return;
  const container = predictiveSearch.querySelector('#predictive-search');
  const input = predictiveSearch.querySelector('#Search');
  if (container) container.style.display = 'none';
  if (input) input.value = '';
};

// redirection on the search page
document.getElementById("Search").addEventListener("keydown", function(e) {
    if (e.key === "Enter") {
        e.preventDefault(); 
        document.querySelector(".results__search-btn span").click();
    }
}); 